import { SourceType } from '@api/api/event-alerts';
import { getTimeTillEndOfDayMs } from '@helpers/utils/dates/getTimeTillEndOfDayMs';
import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import {
  getSingleSubscription,
  getSubscriptions,
} from '@terminal/services/alerts/event-alerts-service';
import { QUERY_KEY_EVENT_ALERT_SUBSCRIPTION } from './event-alerts-query-keys';

export const useGetSingleSubscription = ({
  sourceType,
  sourceId,
  enabled = true,
}: {
  sourceType: SourceType;
  sourceId: string;
  enabled?: boolean;
}) =>
  useQuery({
    queryKey: [QUERY_KEY_EVENT_ALERT_SUBSCRIPTION, sourceId, sourceType],
    queryFn: () =>
      getSingleSubscription({
        sourceType,
        sourceId,
      }),
    enabled,
  });

export const useGetSubscriptions = ({
  sourceType,
  limit = 20,
  enabled = true,
}: {
  sourceType: SourceType;
  limit?: number;
  enabled?: boolean;
}) =>
  useInfiniteQuery({
    queryKey: [QUERY_KEY_EVENT_ALERT_SUBSCRIPTION, sourceType, limit],
    queryFn: ({ pageParam }) =>
      getSubscriptions({
        sourceType,
        next: pageParam ?? undefined,
        limit,
      }),
    enabled,
    initialPageParam: null as string | null,
    getNextPageParam: (lastPage): string | null =>
      lastPage?.next_cursor ?? null,
    staleTime: getTimeTillEndOfDayMs(),
  });
